import { contragentAvrApi } from "../api";

export const listContragentAvr = async (remontId) => {
  try {
    const res = await contragentAvrApi.list(remontId);
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

export const listContractorAgreementForAvrModal = async (remontId) => {
  try {
    const res = await contragentAvrApi.listContractorAgreementForAvrModal(remontId);
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

export const createContragentAvr = async (body) => {
  try {
    await contragentAvrApi.create(body);
    return true;
  } catch (e) {
    return false;
  }
};

export const signContragentAvr = async (contragentAvrId, body) => {
  try {
    const res = await contragentAvrApi.sign(contragentAvrId, body);
    return res?.sign_url ?? null;
  } catch (e) {
    return null;
  }
};

export const downloadSignedAvr = async (contragentAvrId) => {
  return contragentAvrApi.downloadSignedAvr(contragentAvrId);
};
